module.exports = __webpack_public_path__ + "static/robesnmore-case-study-53d58cb1c94773e7ab8a9b07e9e73f76.webp";